(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Secondary-img-video-slider"] && !Shopify.designMode) return;
  try {
    
  class GeneralImgVideoSlider extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      let index = 0
      let len = this.getAttribute('len')
      let sid = this.getAttribute('sid')
      let duration = this.getAttribute('duration') * 1000
      let className = '.swiper-' + sid
      let oVideos = this.querySelectorAll(className + ' .full-vid')
      let autoplay = undefined
      if (duration) {
        autoplay = {
          delay: duration,
          disableOnInteraction: false
        }
      }
      const updateHeaderStyleAndLogo = (slide) => {
        const headerColor = getComputedStyle(slide).getPropertyValue('--header-color')
        document.documentElement.style.setProperty('--header-text-color', headerColor)
        const logoSrc = slide.dataset.logo
        const logo = document.querySelector('#shopify-section-header-inline .header__normal-logo')
        const stickyLogoSrc = document.querySelector('#shopify-section-header-inline .header__sticky-logo').src
        if (logo) {
          if (logoSrc) {
            logo.src = logoSrc
            logo.srcset = logoSrc
          } else {
            logo.src = stickyLogoSrc
            logo.srcset = stickyLogoSrc
          }
        }
        const logoMobile = document.querySelector('#shopify-section-header-inline .header__mobile-logo')
        if (logoMobile) {
          if (logoSrc) {
            logoMobile.src = logoSrc
            logoMobile.srcset = logoSrc
          } else {
            logoMobile.src = stickyLogoSrc
            logoMobile.srcset = stickyLogoSrc
          }
        }
      }
      if (len > 1) {
        const swiper = new Swiper(className, {
          loop: true,
          // autoplay,
          navigation: {
            nextEl: '.givs-next',
            prevEl: '.givs-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            slideChange() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            },
            init() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            }
          }
        })
      }
      let ob = new IntersectionObserver(
        (e) => {
          let entry = e[0]
          if (entry.isIntersecting) {
            if (index === 0) {
              if (oVideos) {
                oVideos.forEach((v) => {
                  v.play()
                })
              }
            }
            index++
          }
        },
        {
          threshold: 0
        }
      )
      let dom = this.querySelector(className)
      ob.observe(dom)
    }
  }
  if (!customElements.get('q-general-img-video-slider')) {
    customElements.define('q-general-img-video-slider', GeneralImgVideoSlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-mechanism-global"] && !Shopify.designMode) return;
  try {
    
  // Swiper 轮播初始化（参考 q-review-slider-active.liquid）
  class ActivityCarousel extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const sid = this.getAttribute('sid');
      const className = '.swiper-activity-' + sid;
      const swiperEl = this.querySelector(className);
      if (!swiperEl || swiperEl.dataset.inited === '1') return;
      
      // 等待 Swiper 加载
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }
      
      swiperEl.dataset.inited = '1';
      new Swiper(className, {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 'auto',
        freeMode: true,
        breakpoints: {
          0: {
            spaceBetween: 7
          },
          750: {
            spaceBetween: 20
          }
        }
      });
    }
  }
  
  if (!customElements.get('activity-carousel')) {
    customElements.define('activity-carousel', ActivityCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-mechanism-us"] && !Shopify.designMode) return;
  try {
    
  // Swiper 轮播初始化（参考 q-review-slider-active.liquid）
  class ActivityCarousel extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const sid = this.getAttribute('sid');
      const className = '.swiper-activity-' + sid;
      const swiperEl = this.querySelector(className);
      if (!swiperEl || swiperEl.dataset.inited === '1') return;
      
      // 等待 Swiper 加载
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }
      
      swiperEl.dataset.inited = '1';
      new Swiper(className, {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 'auto',
        freeMode: true,
        breakpoints: {
          0: {
            spaceBetween: 7
          },
          750: {
            spaceBetween: 20
          }
        }
      });
    }
  }
  
  if (!customElements.get('activity-carousel')) {
    customElements.define('activity-carousel', ActivityCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Mpdesc extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      let oDescwrap = this.querySelector(".mp-desc-maxheight");
      let oDescMain = this.querySelector(".t4s-product__description");
      let oDescMore = this.querySelector(".mp-desc-more");

      if (!oDescwrap || !oDescMain || !oDescMore) return;

      const oKeySellingPoint = this.querySelector(".mp-desc-key-selling-point");
      const hasKeySellingPoint = this.dataset.showKeySellingPoint === 'true' && !!oKeySellingPoint;

      if (hasKeySellingPoint) {
        oDescMore.style.display = 'block';
      }

      oDescMore.addEventListener("click", () => {
        if (hasKeySellingPoint) {
          oKeySellingPoint.classList.add('is-expanded');
        }

        oDescMore.style.display = 'none';
      });
    }
  }

  if (!customElements.get('q-mp-desc')) {
    customElements.define('q-mp-desc', Mpdesc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-top"] && !Shopify.designMode) return;
  try {
    
  class Mpdesc extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const oKeySellingPoint = this.querySelector('.mp-desc-key-selling-point[data-show-key-selling-point="true"]');
      const oKeySellingPointMore = oKeySellingPoint ? oKeySellingPoint.querySelector('.mp-desc-more') : null;

      if (oKeySellingPoint && oKeySellingPointMore) {
        oKeySellingPointMore.style.display = 'block';

        oKeySellingPointMore.addEventListener('click', () => {
          oKeySellingPoint.classList.add('is-expanded');
          oKeySellingPointMore.style.display = 'none';
        });
      }
    }
  }

  if (!customElements.get('q-mp-desc')) {
    customElements.define('q-mp-desc', Mpdesc);
  }

  // 修复导航栏固定定位和下拉菜单加载问题
  (function () {
    // 1. 确保导航栏可以固定定位
    function enableStickyHeader() {
      try {
        const body = document.body;
        const html = document.documentElement;
        if (body && !body.classList.contains('t4s-hsticky__ready')) {
          body.classList.add('t4s-hsticky__ready');
        }
        if (html && !html.classList.contains('t4s-hsticky__ready')) {
          html.classList.add('t4s-hsticky__ready');
        }
      } catch (e) {}
    }

    // 2. 加载菜单内容的函数 - 支持 drop 和 mega 两种类型
    function loadMenuContent(lazyMenu) {
      if (!lazyMenu || !lazyMenu.getAttribute) return;

      // 检查是否已经加载或正在加载
      if (lazyMenu.classList.contains('t4s-loaded') || lazyMenu.classList.contains('t4s-loading')) {
        return;
      }

      // 检查是 drop 类型（data-handle）还是 mega 类型（data-id）
      const handle = lazyMenu.getAttribute('data-handle');
      const menuId = lazyMenu.getAttribute('data-id');

      if (!handle && !menuId) {
        return;
      }

      lazyMenu.classList.add('t4s-loading');

      // 根据菜单类型选择不同的加载 URL
      let menuUrl;
      if (handle) {
        // Drop 类型菜单：使用 data-handle
        let menuHandle = handle;

        if (handle === 'explore') {
          menuUrl = '/search?type=article&q=' + encodeURIComponent(menuHandle) + '+ntt4tag&section_id=dropdown-menu';
        } else {
          menuUrl =
            '/search?type=article&q=' + encodeURIComponent(menuHandle) + '_bid+ntt4tag&section_id=dropdown-menu';
        }
      } else if (menuId) {
        // Mega 类型菜单：使用 data-id
        menuUrl = '/search?type=article&q=' + encodeURIComponent(menuId) + '_bid+ntt4tag&section_id=mega-menu';
      } else {
        lazyMenu.classList.remove('t4s-loading');
        return;
      }

      fetch(menuUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Network error');
          return response.text();
        })
        .then(function (html) {
          if (!lazyMenu || !lazyMenu.parentNode) return;

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          let menuContent;
          let contentHTML = '';

          if (menuId) {
            menuContent =
              doc.querySelector('#t4s-mega-contents' + menuId) ||
              doc.querySelector('[data-id="' + menuId + '"].t4s-mega-contents') ||
              doc.querySelector('.t4s-mega-contents[data-id="' + menuId + '"]') ||
              doc.querySelector('[data-id="' + menuId + '"]') ||
              doc.querySelector('.t4s-mega-contents');

            if (menuContent) {
              contentHTML = menuContent.innerHTML;
            } else {
              const existingMega =
                document.querySelector('#t4s-mega-contents' + menuId) ||
                document.querySelector('[data-id="' + menuId + '"].t4s-mega-contents') ||
                document.querySelector('.t4s-mega-contents[data-id="' + menuId + '"]');

              if (existingMega) {
                contentHTML = existingMega.innerHTML;
              }
            }
          } else {
            menuContent = doc.querySelector('#shopify-section-dropdown-menu');

            if (menuContent) {
              contentHTML = menuContent.innerHTML;
              contentHTML = contentHTML
                .replace(/\[nt_drop_split1\]/g, '')
                .replace(/\[nt_drop_split2\]/g, '')
                .trim();
            }
          }

          if (contentHTML && contentHTML.trim() !== '') {
            const loadingBg = lazyMenu.querySelector('.t4s-loading--bg');
            if (loadingBg) loadingBg.remove();

            if (menuId) {
              const tempContainer = document.createElement('div');
              tempContainer.innerHTML = contentHTML;

              const links = tempContainer.querySelectorAll('link[rel="stylesheet"]');
              const styles = tempContainer.querySelectorAll('style');

              links.forEach(function (link) {
                if (!document.querySelector('link[href="' + link.getAttribute('href') + '"]')) {
                  document.head.appendChild(link.cloneNode(true));
                }
              });

              styles.forEach(function (style) {
                document.head.appendChild(style.cloneNode(true));
              });

              links.forEach(function (link) {
                link.remove();
              });

              styles.forEach(function (style) {
                style.remove();
              });

              lazyMenu.innerHTML = tempContainer.innerHTML;
            } else {
              lazyMenu.innerHTML = contentHTML;
            }

            lazyMenu.classList.remove('t4s-loading');
            lazyMenu.classList.add('t4s-loaded');

            if (menuId) {
              setTimeout(function () {
                if (window['showContent' + menuId] && typeof window['showContent' + menuId] === 'function') {
                  try {
                    window['showContent' + menuId](1);
                  } catch (e) {}
                }
              }, 200);
            }
          }
        })
        .catch(function (error) {
          if (lazyMenu && lazyMenu.parentNode) {
            lazyMenu.classList.remove('t4s-loading');
          }
        });
    }

    // 3. 监听菜单项 hover 并加载内容
    function setupMenuLoad() {
      try {
        const menuItems = document.querySelectorAll(
          '.t4s-section-header .t4s-menu-item.has--children, .t4s-section-header .t4s-nav__ul > li.has--children'
        );

        menuItems.forEach(function (menuItem) {
          if (!menuItem || !menuItem.parentNode) return;

          menuItem.addEventListener(
            'mouseenter',
            function () {
              try {
                const subMenu = menuItem.querySelector('.t4s-sub-menu');
                if (subMenu) {
                  const lazyMenus = subMenu.querySelectorAll('.t4s-lazy_menu[data-handle], .t4s-lazy_menu[data-id]');
                  lazyMenus.forEach(function (lazyMenu) {
                    if (
                      lazyMenu &&
                      !lazyMenu.classList.contains('t4s-loaded') &&
                      !lazyMenu.classList.contains('t4s-loading')
                    ) {
                      loadMenuContent(lazyMenu);
                    }
                  });
                }
              } catch (e) {}
            },
            { passive: true }
          );
        });
      } catch (e) {}
    }

    enableStickyHeader();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        enableStickyHeader();
        setTimeout(setupMenuLoad, 100);
      });
    } else {
      setTimeout(setupMenuLoad, 100);
    }

    setTimeout(function () {
      enableStickyHeader();
      setupMenuLoad();
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-anchor"] && !Shopify.designMode) return;
  try {
    
class ProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.navBtns = this.querySelectorAll(".qaan-top-btn")
    this.init()
  }
  init () {
    window.addEventListener("scroll", () => {
      let t = document.documentElement.scrollTop + 0
      let oWrap = this.querySelector('.qaan-wrap')
      let oFixed = this.querySelector('.qaan-fixed')
      let top = oWrap.offsetTop
      if (top < t) {
        oFixed.setAttribute("show", "1")
      } else {
        oFixed.setAttribute("show", "")
      }
    })

    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        this.navBtns.forEach((ite) => {
          ite.setAttribute("show", "")
        })
        this.navBtns.forEach((item,i) => {
          // console.log(item.getAttribute('data-id'),entry.target.getAttribute("id"))
          if (item.getAttribute('data-id') === entry.target.getAttribute("id")) {
            item.setAttribute('show', "1")
          }
        })
      }
    }, {
      threshold: 0.5
    })

    this.navBtns.forEach((item,i) => {
      let id = item.getAttribute("data-id")
      let dom = document.querySelector("#" + id)
      // console.log(dom, 123)
      if (dom) {
        ob.observe(dom)
      }
      item.addEventListener("click", () => {
        // console.log(dom, dom.offsetTop)
        let top = dom.offsetTop
        // let top = dom.getBoundingClientRect().top
        // let top = dom.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: top - 65,
          behavior: "smooth"
        })
      })
    })
  }
}
if (!customElements.get('q-product-anchor')) {
  customElements.define('q-product-anchor', ProductAnchor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-animation"] && !Shopify.designMode) return;
  try {
    
class AboutAnimation extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let speed = this.getAttribute("speed") * 100
    let opacity = this.getAttribute("opacity")
    gsap.registerPlugin(ScrollTrigger)
    let st = ScrollTrigger.create({
      trigger: ".qanim-an-wrap",
      start: "top top",
      end: "+=" + speed,
      scrub: true,
      markers: false,
      pin:true,
      animation: gsap.timeline()
      .fromTo(
        ".qanim-logo", 
        {
          transform:'scale(1)',
          opacity: "1"
        }, 
        {
          transform:'scale(2)',ease: ">",
          opacity: "0"
        }
      )
      .fromTo(
        ".qanim-mask", 
        {
          opacity: opacity
        }, 
        {
          ease: "none",
          opacity: "0"
        }
      )
      .fromTo(
        ".qanim-item1", 
        {
          top: "260px",
          opacity: "0",
        }, 
        {
          top: "180px",
          opacity: "1"
        }
      )
      .fromTo(
        ".qanim-item1", 
        {
          opacity: "1",
        }, 
        {
          opacity: "1"
        }
      )
      .fromTo(
        ".qanim-item1", 
        {
          // top: "50%",
          // opacity: "1"
          transform:'translateX(-50%) scale(1)',
        },
        {
          // top: "40%",
          // opacity: "0",
          transform:'translateX(-50%) scale(0)',
        }
      )
      .fromTo(
        ".qanim-item2", 
        {
          top: "260px",
          opacity: "0",
        }, 
        {
          top: "180px",
          opacity: "1"
        }
      )
      .fromTo(
        ".qanim-item2", 
        {
          opacity: "1",
        }, 
        {
          opacity: "1"
        }
      )
      .fromTo(
        ".qanim-item2", 
        {
          // top: "50%",
          // opacity: "1"
          transform:'translateX(-50%) scale(1)',
        },
        {
          // top: "40%",
          // opacity: "0",
          transform:'translateX(-50%) scale(0)',
        }
      )
      .fromTo(
        ".qanim-item3", 
        {
          top: "260px",
          opacity: "0",
        }, 
        {
          top: "180px",
          opacity: "1"
        }
      )
      .fromTo(
        ".qanim-item3", 
        {
          opacity: "1",
        }, 
        {
          opacity: "1"
        }
      )
      // .fromTo(
      //   ".qanim-item2", 
      //   {
      //     top: "50%",
      //     opacity: "1"
      //   },
      //   {
      //     top: "40%",
      //     opacity: "0",
      //   }
      // )
    });
  }
}
if (!customElements.get('q-about-animation')) {
  customElements.define('q-about-animation', AboutAnimation);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-banner"] && !Shopify.designMode) return;
  try {
    
  class AboutBanner extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init() {
      let oPlayBtn = this.querySelector('.qaba-main-btn');
      let mask = this.querySelector('.qvs-mask');
      let maskClose = this.querySelector('.qvs-mask-close');
      let oVideo = this.querySelector('.qvs-big-video');
      maskClose.addEventListener('click', () => {
        mask.setAttribute('show', '0');
        oVideo.pause();
      })
      oPlayBtn.addEventListener('click', () => {
        mask.setAttribute('show', '1');
        oVideo.play();
      })
    }
  }
  if (!customElements.get('q-about-banner')) {
    customElements.define('q-about-banner', AboutBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-img-slider-1"] && !Shopify.designMode) return;
  try {
    
  class CusWidthSlider1 extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let size = this.getAttribute('size') * 1
      let className = '.swiper-' + sid
      if (size < 2) {
        return
      }
      const swiper = new Swiper(className, {
        loop: true,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 0,
            slidesPerView: '1',

          }
        },
        navigation: {
          nextEl: '.qais1-next',
          prevEl: '.qais1-prev',
        }
      });
      let sliders = this.querySelectorAll('.swiper-slide');
      let oSwiper = this.querySelector('.qais1-swiper');
      let calcSwiper = () => {
        let w = swiper.$el[0].clientWidth
        let sw = 0
        sliders.forEach(s => {
          let width = s.clientWidth
          sw += width
        })
        if (w > sw) {
          oSwiper.setAttribute("center", "1")
        } else {
          oSwiper.setAttribute("center", "")
        }
      }

      window.addEventListener('resize', () => {
        calcSwiper()
      })
      calcSwiper()
    }
  }
  if (!customElements.get('q-cus-width-slider1')) {
    customElements.define('q-cus-width-slider1', CusWidthSlider1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-map"] && !Shopify.designMode) return;
  try {
    
  class QAnimatedNumber extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sectionId = this.getAttribute("section-id")
      let num = this.getAttribute("end") * 1
      let oCount = this.querySelector(".qama-count")
      if (num) {
        let start = null;
        let duration = 2000;
        let observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              const step = (timestamp) => {
                if (!start) start = timestamp;
                let progress = timestamp - start;
                let current = Math.min(Math.floor(progress / duration * num), num);
                oCount.textContent = current;
                if (progress < duration) {
                  window.requestAnimationFrame(step);
                }
              };
              window.requestAnimationFrame(step);
            }
          });
        }, { threshold: 0.1 });
        observer.observe(this);
      }
    }
  }
  if (!customElements.get('q-animated-number')) {
    customElements.define('q-animated-number', QAnimatedNumber);
  }

  class qAboutMap extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let oVideo = this.querySelector(".qama-video")
      if (oVideo) {
        let observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              oVideo.play();
            }
          });
        }, { threshold: 0.1 });
        observer.observe(oVideo);
      }
      
    }
  }
  if (!customElements.get('q-about-map')) {
    customElements.define('q-about-map', qAboutMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-products-detail_slide"] && !Shopify.designMode) return;
  try {
    
  class SocialCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let className = '.swiper-' + sid
      const isMobile = window.innerWidth < 750
      // 计算1rem对应的像素值
      const getRemValue = () => {
        return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16
      }
      const remValue = getRemValue()
      const swiper = new Swiper(className, {
        loop: false,
        spaceBetween: isMobile ? remValue : 12,
        slidesPerView: 'auto',
        allowTouchMove: true,
        breakpoints: {
          750: {
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.qaps-next',
          prevEl: '.qaps-prev',
        },
        pagination: {
          el: '.qaps-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          }
        }
      });
      let sliders = this.querySelectorAll('.swiper-slide');
      let oSwiper = swiper.$el[0]
      let calcSwiper = () => {
        let w = swiper.$el[0].clientWidth
        let sw = 0
        sliders.forEach(s => {
          let width = s.clientWidth
          sw += width
        })
        if (w > sw) {
          oSwiper.setAttribute("center", "1")
        } else {
          oSwiper.setAttribute("center", "")
        }
      }

      window.addEventListener('resize', () => {
        calcSwiper()
      })
      calcSwiper()
    }
  }
  if (!customElements.get('q-social-cards')) {
    customElements.define('q-social-cards', SocialCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-about-products-slider"] && !Shopify.designMode) return;
  try {
    
  class SocialCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let className = '.swiper-' + sid
      const swiper = new Swiper(className, {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.qaps-next',
          prevEl: '.qaps-prev',
        }
      });
      let sliders = this.querySelectorAll('.swiper-slide');
      let oSwiper = swiper.$el[0]
      let calcSwiper = () => {
        let w = swiper.$el[0].clientWidth
        let sw = 0
        sliders.forEach(s => {
          let width = s.clientWidth
          sw += width
        })
        if (w > sw) {
          oSwiper.setAttribute("center", "1")
        } else {
          oSwiper.setAttribute("center", "")
        }
      }

      window.addEventListener('resize', () => {
        calcSwiper()
      })
      calcSwiper()
    }
  }
  if (!customElements.get('q-social-cards')) {
    customElements.define('q-social-cards', SocialCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-active-img-video-slider"] && !Shopify.designMode) return;
  try {
    
  class GeneralImgVideoSlider extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      let index = 0
      let len = this.getAttribute('len')
      let sid = this.getAttribute('sid')
      let duration = this.getAttribute('duration') * 1000
      let className = '.swiper-' + sid
      let oVideos = this.querySelectorAll(className + ' .full-vid')
      let autoplay = undefined
      if (duration) {
        autoplay = {
          delay: duration,
          disableOnInteraction: false
        }
      }
      const updateHeaderStyleAndLogo = (slide) => {
        const headerColor = getComputedStyle(slide).getPropertyValue('--header-color')
        document.documentElement.style.setProperty('--header-text-color', headerColor)
        const logoSrc = slide.dataset.logo
        const logo = document.querySelector('#shopify-section-header-inline .header__normal-logo')
        const stickyLogoSrc = document.querySelector('#shopify-section-header-inline .header__sticky-logo').src
        if (logo) {
          if (logoSrc) {
            logo.src = logoSrc
            logo.srcset = logoSrc
          } else {
            logo.src = stickyLogoSrc
            logo.srcset = stickyLogoSrc
          }
        }
        const logoMobile = document.querySelector('#shopify-section-header-inline .header__mobile-logo')
        if (logoMobile) {
          if (logoSrc) {
            logoMobile.src = logoSrc
            logoMobile.srcset = logoSrc
          } else {
            logoMobile.src = stickyLogoSrc
            logoMobile.srcset = stickyLogoSrc
          }
        }
      }
      if (len > 1) {
        const swiper = new Swiper(className, {
          loop: true,
          // autoplay,
          navigation: {
            nextEl: '.givs-next',
            prevEl: '.givs-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            slideChange() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            },
            init() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            }
          }
        })
      }
      let ob = new IntersectionObserver(
        (e) => {
          let entry = e[0]
          if (entry.isIntersecting) {
            if (index === 0) {
              if (oVideos) {
                oVideos.forEach((v) => {
                  v.play()
                })
              }
            }
            index++
          }
        },
        {
          threshold: 0
        }
      )
      let dom = this.querySelector(className)
      ob.observe(dom)
    }
  }
  if (!customElements.get('q-general-img-video-slider')) {
    customElements.define('q-general-img-video-slider', GeneralImgVideoSlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-affiliate-grid"] && !Shopify.designMode) return;
  try {
    
  let qafgrCode = document.querySelectorAll('.qafgr-code');
  qafgrCode.forEach((item) => {
    item.addEventListener('click', () => {
      let text = item.getAttribute('data-text');
      navigator.clipboard.writeText(text).then(() => {
        alert('Copied to clipboard');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-banner-and-text"] && !Shopify.designMode) return;
  try {
    
// class qBannerAndText extends HTMLElement {
//   constructor() {
//     super();
//     this.init()
//   }
//   init () {
//     let sectionId = this.getAttribute("section-id")
//     let oItem = this.querySelector(".qbat-main-img")
//     console.log(123, oItem)
//     if (oItem) {
//       oItem.addEventListener("click", () => {
//         let btn = document.querySelector(".chat-toggle")
//         console.log(btn)
//         btn.click()

//       })
//     }
    
//   }
// }
// if (!customElements.get('q-banner-and-text')) {
//   customElements.define('q-banner-and-text', qBannerAndText);
// }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-big-video-slider"] && !Shopify.designMode) return;
  try {
    
  class BigVideoSlider extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let sectionId = this.getAttribute("section-id")
    let className = `.swiper-${sectionId}`
    const swiper = new Swiper(className, {
      loop: true,
      spaceBetween: 12,
      slidesPerView: 'auto',
      centeredSlides: false,
      breakpoints: {
        750: {
          spaceBetween: 20,
          centeredSlides: true,
        }
      },
      navigation: {
        nextEl: '.qbvs-next',
        prevEl: '.qbvs-prev',
      }
    });

    let oVideos = this.querySelectorAll('.qbvs-video')
    let oFirstVideo = this.querySelector(".swiper-slide-active .qbvs-video")
    swiper.on('activeIndexChange', (e) => {
      oVideos.forEach(item => {
        item.pause()
      })
      oVideos[e.activeIndex].play()
    })

    let index = 0
    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        if (index) {
          return
        }
        oFirstVideo.play()
        index++
      }
    }, {
      threshold: 0
    })
    ob.observe(oFirstVideo)
  }
}
if (!customElements.get('q-big-video-slider')) {
  customElements.define('q-big-video-slider', BigVideoSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-compatible-devices"] && !Shopify.designMode) return;
  try {
    
class Compatible extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let tabs = this.querySelectorAll(".qcd-tab")
    let sid = this.getAttribute("sid")
    let className = '.swiper-' + sid

    const swiper = new Swiper(className, {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 'auto',
    });
    swiper.on('activeIndexChange', (e) => {
      tabs.forEach(item => {
        item.setAttribute("show", "")
      })
      tabs[e.activeIndex].setAttribute("show", "1")
    })
    tabs.forEach((item,i) => {
      item.addEventListener("click", () => {
        swiper.slideTo(i)
      })
    })


  }
}
if (!customElements.get('q-compatible')) {
  customElements.define('q-compatible', Compatible);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-digital-frame"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initPortableMonitorVideos() {
      const sections = document.querySelectorAll('[data-portable-monitor-section]');
      sections.forEach((section) => {
        const videos = section.querySelectorAll('video');
        videos.forEach((video) => {
          if (video.dataset.initialized) return;
          video.dataset.initialized = 'true';
          
          // 监听视频播放完成事件，停留在最后一帧
          video.addEventListener('ended', function() {
            this.pause();
            // 确保停留在最后一帧（通过设置currentTime为duration）
            if (this.duration) {
              this.currentTime = this.duration;
            }
          });

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 如果视频已播放完成，不再自动播放
                if (!video.ended) {
                  video.play().catch(() => {
                    // 忽略自动播放失败
                  });
                }
              } else {
                video.pause();
              }
            });
          }, {
            threshold: 0.5
          });
          observer.observe(video);
        });
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPortableMonitorVideos);
    } else {
      initPortableMonitorVideos();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-faq-main"] && !Shopify.designMode) return;
  try {
    
class ExtandWrap extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let oItems = this.querySelectorAll(".extand-item")
    // let oTabs = this.querySelectorAll(".extand-tab")
    // let oContents = this.querySelectorAll(".extand-content-wrap")
    // let oContent1s = this.querySelectorAll(".extand-content-item")
    // oItems.forEach((tab, i) => {
    //   tab.addEventListener("click", () => {
    //     let height = oContent1s[i].offsetHeight
    //     if (!oContents[i].offsetHeight) {
    //       oContents[i].style.height = height + 'px'
    //       oItems[i].setAttribute("show", 1)
    //     } else {
    //       oContents[i].style.height = '0px'
    //       oItems[i].setAttribute("show", '')
    //     }
    //   })
    // })
  }
}
if (!customElements.get('q-extand')) {
  customElements.define('q-extand', ExtandWrap);
}

class qfmMain extends HTMLElement {
  constructor() {
    super();
    this.init()
    this.mdFilterOpenClose()
  }
  init () {
    // let oTabs = this.querySelectorAll(".qfm-left-subtitle")
    let oTabs = this.querySelectorAll(".qfm-left-title")
    let oTabsMd = this.querySelectorAll(".qfm-left-title-md")
    let oCateTitle = this.querySelector(".qfm-left .qfm-left-title")
    if (oCateTitle) {
      oCateTitle.click()
    }
    this.cateClickFn(oTabs)
    this.cateClickFn(oTabsMd)
    this.initShowMore()
  }
  // 处理分类点击事件
  cateClickFn (btns) {
    let oContent = this.querySelectorAll(".qfm-right-item")
    btns.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        let title_text = tab.getAttribute("title_text")
        let currentContent = null
        btns.forEach((tab, j) => {
          tab.setAttribute("show", '')
        })
        oContent.forEach((content, j) => {
          content.setAttribute("show", '')
          // if (content.getAttribute("title_text") === title_text) {
          //   currentContent = content
          // }
        })
        currentContent = oContent[i]
        tab.setAttribute("show", '1')
        if (currentContent) {
          currentContent.setAttribute("show", '1')
        }
        let top = this.offsetTop - 60
        if (document.documentElement.scrollTop > top) {
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }

      })
      if (i === 0) {
        tab.click()
      }
    })
  }
  // 开启 关闭移动端弹窗
  mdFilterOpenClose () {
    let oOpen = this.querySelector(".qfm-md-filter-btn>div")
    let oClose = this.querySelector(".qfm-d-header")
    let oMask = this.querySelector(".qfm-mask")
    // let oCateTitle = this.querySelector(".qfm-mask .qfm-left-title")

    oOpen.addEventListener('click', () => {
      oMask.setAttribute("show", '1')
    })
    oClose.addEventListener('click', () => {
      oMask.setAttribute("show", '')
    })

  }
  initShowMore () {
    let oMoreBtn = this.querySelectorAll(".qfm-max-more")
    let oMoreBtnDiv = this.querySelectorAll(".qfm-max-more>div")
    let oMaxHeight = this.querySelectorAll(".qfm-max-height")
    let oGetHeight = this.querySelectorAll(".qfm-getHeight")
    oMaxHeight.forEach((item,i) => {
      if (oGetHeight[i].clientHeight > oMaxHeight[i].clientHeight) {
        oMoreBtn[i].style.display = 'flex'
      }
    })
    oMoreBtnDiv.forEach((item,i) => {
      item.addEventListener('click', () => {
        oMaxHeight[i].setAttribute("show", '1')
      })
    })

    window.addEventListener('resize', () => {
      oMaxHeight.forEach((item,i) => {
        if (oGetHeight[i].clientHeight > oMaxHeight[i].clientHeight) {
          oMoreBtn[i].style.display = 'flex'
        } else {
          oMoreBtn[i].style.display = 'none'
        }
      })
    })

  }
}
if (!customElements.get('q-faq-main')) {
  customElements.define('q-faq-main', qfmMain);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-featured-blog-and-news"] && !Shopify.designMode) return;
  try {
    
  class FeaturedBlogAndNews extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }
    
    connectedCallback() {
      this.init();
    }
    
    init() {
      let sid = this.getAttribute('sid');
      let className = '.swiper-' + sid;
      
      // 初始化 Swiper
      this.swiper = new Swiper(className, {
        spaceBetween: 20,
        slidesPerView: 'auto',
        
        loop: false,
        speed: 800,
        navigation: {
          nextEl: '.fban-next',
          prevEl: '.fban-prev',
        },
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
          480: {
            spaceBetween: 15,
          }
        }
      });
    }
  }
  
  if (!customElements.get('q-featured-blog-and-news')) {
    customElements.define('q-featured-blog-and-news', FeaturedBlogAndNews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-full-products-slide"] && !Shopify.designMode) return;
  try {
    
  class FullProductsCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      const container = this;
      const slides = container.querySelectorAll('.qfps-slide-item');
      const paginationEl = container.querySelector('.qfps-pagination-' + sid);
      const textElement = container.querySelector('.qfps-slide-text');
      
      // 创建指示器
      slides.forEach((slide, index) => {
        const indicator = document.createElement('span');
        indicator.className = 'qfps-indicator' + (index === 0 ? ' active' : '');
        const indicatorText = slide.getAttribute('data-indicator-text');
        indicator.textContent = indicatorText && indicatorText.trim() !== '' ? indicatorText : (index + 1);
        
        indicator.addEventListener('click', () => {
          // 切换slide - 实现渐隐渐显效果
          const currentActive = container.querySelector('.qfps-slide-item.active');
          const targetSlide = slides[index];
          
          // 如果点击的是当前激活的slide，不做任何操作
          if (currentActive === targetSlide) {
            return;
          }
          
          // 移除所有slide的active类（触发渐隐）
          slides.forEach((s) => {
            s.classList.remove('active');
          });
          
          // 短暂延迟后添加新的active类（触发渐显），实现平滑过渡
          requestAnimationFrame(() => {
            targetSlide.classList.add('active');
          });
          
          // 切换指示器
          paginationEl.querySelectorAll('.qfps-indicator').forEach((ind, i) => {
            if (i === index) {
              ind.classList.add('active');
            } else {
              ind.classList.remove('active');
            }
          });
          
          // 切换文本
          if (textElement) {
            const slideText = slide.getAttribute('data-slide-text') || '';
            textElement.textContent = slideText;
            
            // 应用文本样式
            const textFont = slide.getAttribute('data-text-font');
            const textSize = slide.getAttribute('data-text-size') || '20';
            const textSizeMd = slide.getAttribute('data-text-size-md') || '16';
            const textLineHeight = slide.getAttribute('data-text-line-height') || '32';
            const textLineHeightMd = slide.getAttribute('data-text-line-height-md') || '24';
            const textColor = slide.getAttribute('data-text-color') || '#000000';
            const textBold = slide.getAttribute('data-text-bold') || 'normal';
            const textItalic = slide.getAttribute('data-text-italic') || 'normal';
            const textUnderline = slide.getAttribute('data-text-underline') || 'none';
            
            if (window.innerWidth >= 750) {
              textElement.style.fontSize = textSize + 'px';
              textElement.style.lineHeight = textLineHeight + 'px';
            } else {
              textElement.style.fontSize = '1.3rem';
              textElement.style.lineHeight = '1.9rem';
            }
            textElement.style.color = textColor;
            textElement.style.fontWeight = textBold;
            textElement.style.fontStyle = textItalic;
            textElement.style.textDecoration = textUnderline;
            if (textFont && textFont.trim() !== '') {
              textElement.style.fontFamily = textFont;
            } else {
              textElement.style.fontFamily = '';
            }
            
            textElement.classList.add('active');
          }
        });
        paginationEl.appendChild(indicator);
      });
      
      // 初始化文本和指示器样式
      if (slides[0]) {
        const firstSlide = slides[0];
        
        if (textElement) {
          const slideText = firstSlide.getAttribute('data-slide-text') || '';
          textElement.textContent = slideText;
          
          // 应用文本样式
          const textFont = firstSlide.getAttribute('data-text-font');
          const textSize = firstSlide.getAttribute('data-text-size') || '20';
          const textSizeMd = firstSlide.getAttribute('data-text-size-md') || '16';
          const textLineHeight = firstSlide.getAttribute('data-text-line-height') || '32';
          const textLineHeightMd = firstSlide.getAttribute('data-text-line-height-md') || '24';
          const textColor = firstSlide.getAttribute('data-text-color') || '#000000';
          const textBold = firstSlide.getAttribute('data-text-bold') || 'normal';
          const textItalic = firstSlide.getAttribute('data-text-italic') || 'normal';
          const textUnderline = firstSlide.getAttribute('data-text-underline') || 'none';
          
          if (window.innerWidth >= 750) {
            textElement.style.fontSize = textSize + 'px';
            textElement.style.lineHeight = textLineHeight + 'px';
          } else {
            textElement.style.fontSize = '1.3rem';
            textElement.style.lineHeight = '1.9rem';
          }
          textElement.style.color = textColor;
          textElement.style.fontWeight = textBold;
          textElement.style.fontStyle = textItalic;
          textElement.style.textDecoration = textUnderline;
          if (textFont && textFont.trim() !== '') {
            textElement.style.fontFamily = textFont;
          }
          
          textElement.classList.add('active');
          
          // 监听窗口大小变化
          window.addEventListener('resize', () => {
            if (textElement.classList.contains('active')) {
              const activeSlide = container.querySelector('.qfps-slide-item.active');
              if (activeSlide) {
                const textSize = activeSlide.getAttribute('data-text-size') || '20';
                const textLineHeight = activeSlide.getAttribute('data-text-line-height') || '32';
                if (window.innerWidth >= 750) {
                  textElement.style.fontSize = textSize + 'px';
                  textElement.style.lineHeight = textLineHeight + 'px';
                } else {
                  textElement.style.fontSize = '1.3rem';
                  textElement.style.lineHeight = '1.9rem';
                }
              }
            }
          });
        }
      }
    }
  }
  if (!customElements.get('q-full-products-cards')) {
    customElements.define('q-full-products-cards', FullProductsCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-general-img-video-slider"] && !Shopify.designMode) return;
  try {
    
  class GeneralImgVideoSlider extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      let index = 0
      let len = this.getAttribute('len')
      let sid = this.getAttribute('sid')
      let duration = this.getAttribute('duration') * 1000
      let className = '.swiper-' + sid
      let oVideos = this.querySelectorAll(className + ' .full-vid')
      let autoplay = undefined
      if (duration) {
        autoplay = {
          delay: duration,
          disableOnInteraction: false
        }
      }
      const updateHeaderStyleAndLogo = (slide) => {
        const headerColor = getComputedStyle(slide).getPropertyValue('--header-color')
        document.documentElement.style.setProperty('--header-text-color', headerColor)
        const logoSrc = slide.dataset.logo
        const logo = document.querySelector('#shopify-section-header-inline .header__normal-logo')
        const stickyLogoSrc = document.querySelector('#shopify-section-header-inline .header__sticky-logo').src
        if (logo) {
          if (logoSrc) {
            logo.src = logoSrc
            logo.srcset = logoSrc
          } else {
            logo.src = stickyLogoSrc
            logo.srcset = stickyLogoSrc
          }
        }
        const logoMobile = document.querySelector('#shopify-section-header-inline .header__mobile-logo')
        if (logoMobile) {
          if (logoSrc) {
            logoMobile.src = logoSrc
            logoMobile.srcset = logoSrc
          } else {
            logoMobile.src = stickyLogoSrc
            logoMobile.srcset = stickyLogoSrc
          }
        }
      }
      if (len > 1) {
        const swiper = new Swiper(className, {
          loop: true,
          // autoplay,
          navigation: {
            nextEl: '.givs-next',
            prevEl: '.givs-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          on: {
            slideChange() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            },
            init() {
              const activeSlide = this.slides[this.activeIndex]
              updateHeaderStyleAndLogo(activeSlide)
            }
          }
        })
      }
      let ob = new IntersectionObserver(
        (e) => {
          let entry = e[0]
          if (entry.isIntersecting) {
            if (index === 0) {
              if (oVideos) {
                oVideos.forEach((v) => {
                  v.play()
                })
              }
            }
            index++
          }
        },
        {
          threshold: 0
        }
      )
      let dom = this.querySelector(className)
      ob.observe(dom)
    }
  }
  if (!customElements.get('q-general-img-video-slider')) {
    customElements.define('q-general-img-video-slider', GeneralImgVideoSlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-policy-cards-waterfall"] && !Shopify.designMode) return;
  try {
    
  class Policywaterfall extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute("sid")
      let doms = this.querySelector(".qpcaw-hidden").children
      const column1 = document.getElementById('column1-' + sid);
      const column2 = document.getElementById('column2-' + sid);
      for (let i = 0; i < doms.length; i++) {
        let item = document.createElement('div');
        item.classList.add('qpcaw-card-wrap');
        item.innerHTML = doms[i].innerHTML
        if (column1.offsetHeight <= column2.offsetHeight) {
          column1.appendChild(item);
        }
        else {
          column2.appendChild(item);
        }
      }
    }
  }
  if (!customElements.get('q-policy-waterfall')) {
    customElements.define('q-policy-waterfall', Policywaterfall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-portable-monitor"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initPortableMonitorVideos() {
      const sections = document.querySelectorAll('[data-portable-monitor-section]');
      sections.forEach((section) => {
        const videos = section.querySelectorAll('video');
        videos.forEach((video) => {
          if (video.dataset.initialized) return;
          video.dataset.initialized = 'true';
          
          // 监听视频播放完成事件，停留在最后一帧
          video.addEventListener('ended', function() {
            this.pause();
            // 确保停留在最后一帧（通过设置currentTime为duration）
            if (this.duration) {
              this.currentTime = this.duration;
            }
          });

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 如果视频已播放完成，不再自动播放
                if (!video.ended) {
                  video.play().catch(() => {
                    // 忽略自动播放失败
                  });
                }
              } else {
                video.pause();
              }
            });
          }, {
            threshold: 0.5
          });
          observer.observe(video);
        });
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPortableMonitorVideos);
    } else {
      initPortableMonitorVideos();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-anchor"] && !Shopify.designMode) return;
  try {
    
class ProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.navBtns = this.querySelectorAll(".qpa-top-btn")
    this.init()
  }
  init () {
    window.addEventListener("scroll", () => {
      let t = document.documentElement.scrollTop + 80
      let oWrap = this.querySelector('.qpa-wrap')
      let oFixed = this.querySelector('.qpa-fixed')
      let top = oWrap.offsetTop
      if (top < t) {
        oFixed.setAttribute("show", "1")
      } else {
        oFixed.setAttribute("show", "")
      }
    })

    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        this.navBtns.forEach((ite) => {
          ite.setAttribute("show", "")
        })
        this.navBtns.forEach((item,i) => {
          if (item.getAttribute('data-id') === entry.target.getAttribute("id")) {
            item.setAttribute('show', "1")
          }
        })
      }
    }, {
      threshold: 0.5
    })

    this.navBtns.forEach((item,i) => {
      let id = item.getAttribute("data-id")
      let dom = document.querySelector("#" + id)
      if (dom) {
        ob.observe(dom)
      }
      item.addEventListener("click", () => {
        let top = dom.offsetTop
        window.scrollTo({
          top: top - 65,
          behavior: "smooth"
        })
      })
    })
  }
}
if (!customElements.get('q-product-anchor')) {
  customElements.define('q-product-anchor', ProductAnchor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-card-slider"] && !Shopify.designMode) return;
  try {
    
  class Swiper1ProductCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      const swiper = new Swiper('.qpcs-swiper', {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 20,
          }
        },
        navigation: {
          nextEl: '.qpcs-next',
          prevEl: '.qpcs-prev',
        }
      });
    }
  }
  if (!customElements.get('q-product-cards')) {
    customElements.define('q-product-cards', Swiper1ProductCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-compare"] && !Shopify.designMode) return;
  try {
    
    class ProductCompare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    
    init() {
        const tabs = this.querySelectorAll('.qcd-tab');
        const contents = this.querySelectorAll('.qcd-compare-content');
        // Tab切换功能
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                // 移除所有tab的active状态
                tabs.forEach(t => {
                    t.setAttribute('show', '');
                });
                        // 隐藏所有内容 - 清除内联样式和属性
                contents.forEach(c => {
                    c.setAttribute('show', '');
                        c.style.display = 'none'; // 强制隐藏，清除之前可能设置的 display: block
                });
                // 隐藏所有手机端参数对比布局
                const mobileParamsWrappers = this.querySelectorAll('.qcd-mobile-params-wrapper');
                mobileParamsWrappers.forEach(wrapper => {
                    wrapper.style.display = 'none';
                });
                // 隐藏所有手机端固定头部
                const mobileStickyHeaders = this.querySelectorAll('.qcd-mobile-sticky-header');
                mobileStickyHeaders.forEach(header => {
                    header.classList.remove('show');
                });
                    // 隐藏所有 PC 端固定头部
                    const stickyHeaders = this.querySelectorAll('.qcd-sticky-header');
                    stickyHeaders.forEach(header => {
                        header.classList.remove('show');
                    });
                // 激活当前tab和内容
                tab.setAttribute('show', '1');
                if (contents[index]) {
                    contents[index].setAttribute('show', '1');
                            // 确保内容显示
                            contents[index].style.display = 'block';
                    // 显示对应的手机端参数对比布局
                    const mobileParamsWrapper = contents[index].querySelector('.qcd-mobile-params-wrapper');
                    if (mobileParamsWrapper && window.innerWidth <= 1024) {
                        mobileParamsWrapper.style.display = 'block';
                        }
                        // 确保产品项显示
                        const compareItems = contents[index].querySelectorAll('.qcd-compare-item');
                            compareItems.forEach((item, itemIndex) => {
                            const isMobile = window.innerWidth <= 1024;
                            if (isMobile) {
                                if (itemIndex < 2) {
                                    item.style.display = 'flex';
                                } else {
                                    item.style.display = 'none'; // 确保隐藏多余项
                                }
                            } else {
                                if (itemIndex < 3) {
                                    item.style.display = 'flex';
                                } else {
                                    item.style.display = 'none'; // 确保隐藏多余项
                    }
                }
            });
                        // 初始化当前tab页的所有产品显示
                        this.initCurrentTabProducts(contents[index]);
                    }
        });
            });
        // 为每个下拉选择器添加事件监听
        this.initSelects();
        // 初始化Buy Now按钮
        this.initBuyNowButtons();
        // 响应式处理
        this.handleResponsive();
        window.addEventListener('resize', () => {
            this.handleResponsive();
        });
        // 初始化手机端参数对比布局的显示状态
        this.initMobileParamsDisplay();
        // 确保第一个tab的内容也被正确初始化
        setTimeout(() => {
            const firstContent = this.querySelector('.qcd-compare-content[show="1"]');
            if (firstContent) {
                this.initCurrentTabProducts(firstContent);
            }
            // 处理初始渲染的 Interface 字段（延迟执行确保DOM完全加载）
            this.initInterfaceFormatting();
        }, 200);
    }
    
    initInterfaceFormatting() {
        try {
            // 处理所有表格中的 Interface 字段（Portable Monitors索引12，Digital Photo Frame索引11）
            const tables = this.querySelectorAll('.qcd-params-table');
            tables.forEach(table => {
                if (!table) return;
                // 查找所有 Interface 行（通过第一列的文本内容）
                const rows = table.querySelectorAll('tbody tr');
                rows.forEach(row => {
                    const firstCell = row.querySelector('td:first-child');
                    if (firstCell && firstCell.textContent.trim() === 'Interface') {
                        // 找到 Interface 行，处理该行的所有数据单元格
                        const dataCells = row.querySelectorAll('td:not(:first-child)');
                        dataCells.forEach(cell => {
                            if (!cell) return;
                            // 检查是否已经处理过（通过检查是否有data-interface-formatted属性）
                            if (cell.hasAttribute('data-interface-formatted')) return;
                            let text = cell.textContent;
                            if (text && text.trim() !== '' && text.trim() !== '-') {
                                // 先清理多余的换行符（将多个连续换行符替换为单个换行符）
                                text = text.replace(/\n{2,}/g, '\n');
                                // 只替换句号+空格为句号+换行，不改变任何其他内容
                                text = text.replace(/\. /g, '.\n');
                                // 清理开头和结尾的换行符
                                text = text.trim();
                                cell.textContent = text;
                                // 标记为已处理
                                cell.setAttribute('data-interface-formatted', 'true');
                            }
                        });
                    }
                });
            });
            // 处理手机端的 Interface 字段
            const mobileParamsWrappers = this.querySelectorAll('.qcd-mobile-params-wrapper');
            mobileParamsWrappers.forEach(wrapper => {
                if (!wrapper) return;
                // 查找所有 Interface 参数项（通过参数名称）
                const paramItems = wrapper.querySelectorAll('.qcd-mobile-param-item');
                paramItems.forEach(item => {
                    const paramName = item.querySelector('.qcd-mobile-param-name');
                    if (paramName && paramName.textContent.trim() === 'Interface') {
                        // 找到 Interface 参数项，处理该参数项的所有值
                        const paramValues = item.querySelectorAll('.qcd-mobile-param-value');
                        paramValues.forEach(cell => {
                            if (!cell) return;
                            // 检查是否已经处理过
                            if (cell.hasAttribute('data-interface-formatted')) return;
                            let text = cell.textContent;
                            if (text && text.trim() !== '' && text.trim() !== '-') {
                                // 先清理多余的换行符
                                text = text.replace(/\n{2,}/g, '\n');
                                // 只替换句号+空格为句号+换行，不改变任何其他内容
                                text = text.replace(/\. /g, '.\n');
                                // 清理开头和结尾的换行符
                                text = text.trim();
                                cell.textContent = text;
                                // 标记为已处理
                                cell.setAttribute('data-interface-formatted', 'true');
                            }
                        });
                    }
                });
            });
        } catch (e) {
            console.error('initInterfaceFormatting错误:', e);
        }
    }
    
    initMobileParamsDisplay() {
        const contents = this.querySelectorAll('.qcd-compare-content');
        contents.forEach((content, index) => {
            if (content.getAttribute('show') === '1') {
                const mobileParamsWrapper = content.querySelector('.qcd-mobile-params-wrapper');
                if (mobileParamsWrapper && window.innerWidth <= 1024) {
                    mobileParamsWrapper.style.display = 'block';
                }
                        // 初始化产品显示
                    this.initCurrentTabProducts(content);
                }
            });
        }
            
        initCurrentTabProducts(content) {
            // 初始化当前tab页的所有产品显示
            const selects = content.querySelectorAll('.qcd-select[data-item]');
            selects.forEach(select => {
                if (select.selectedIndex >= 0) {
                    const itemIndex = parseInt(select.getAttribute('data-item'));
                    const optionIndex = select.selectedIndex;
                    this.updateProductDisplay(itemIndex, optionIndex);
            }
        });
    }
    
    initSelects() {
        const selects = this.querySelectorAll('.qcd-select');
        selects.forEach((select) => {
            select.addEventListener('change', (e) => {
                const itemIndex = parseInt(select.getAttribute('data-item'));
                const tabIndex = parseInt(select.getAttribute('data-tab'));
                const value = e.target.value;
                // 同步所有相同位置的下拉选择器（包括固定头部和原始位置）
                const allSelects = this.querySelectorAll(`.qcd-select[data-item="${itemIndex}"][data-tab="${tabIndex}"]`);
                allSelects.forEach(s => {
                    if (s !== select) {
                        s.value = value;
                    }
                });
                this.updateProductDisplay(itemIndex, parseInt(value));
            });
        });
        // 监听滚动，当滚动到表格时显示固定头部
        this.initStickyHeader();
        // 监听滚动，当滚动到手机端参数对比时显示固定头部
        this.initMobileStickyHeader();
    }
    
    initBuyNowButtons() {
        const buyNowButtons = this.querySelectorAll('.qcd-buy-now-btn');
        buyNowButtons.forEach(button => {
                button.addEventListener('click', async (e) => {
                e.preventDefault();
                    const itemIndex = parseInt(button.getAttribute('data-item'));
                    const tabIndex = parseInt(button.getAttribute('data-tab'));
                    
                    // 获取当前显示的内容
                    const content = this.querySelector(`.qcd-compare-content[show="1"]`);
                    if (!content) return;
                    // 获取对应的下拉选择器
                    const select = content.querySelector(`.qcd-select[data-item="${itemIndex}"][data-tab="${tabIndex}"]`);
                    if (!select) return;
                    // 获取选中的选项
                    const selectedOption = select.options[select.selectedIndex];
                    if (!selectedOption) return;
                    // 获取 variant ID
                    const variantId = selectedOption.getAttribute('data-variant-id');
                    if (variantId) {
                        // 添加产品到购物车
                        try {
                            const response = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: variantId,
                                    quantity: 1
                                })
                            });
                            if (response.ok) {
                                // 添加成功，跳转到结算页面
                window.location.href = '/checkout';
                            } else {
                                // 添加失败，显示错误信息或跳转到产品页面
                                const productUrl = selectedOption.getAttribute('data-product-url');
                                if (productUrl) {
                                    window.location.href = productUrl;
                                }
                            }
                        } catch (error) {
                            console.error('添加产品到购物车失败:', error);
                            // 出错时跳转到产品页面
                            const productUrl = selectedOption.getAttribute('data-product-url');
                            if (productUrl) {
                                window.location.href = productUrl;
                            }
                        }
                    } else {
                        // 如果没有 variant ID，跳转到产品详情页
                        const productUrl = selectedOption.getAttribute('data-product-url');
                        if (productUrl) {
                            window.location.href = productUrl;
                        }
                    }
            });
        });
    }
    
     initStickyHeader() {
        const tables = this.querySelectorAll('.qcd-params-table');
        const stickyHeaders = this.querySelectorAll('.qcd-sticky-header');
        if (tables.length === 0 || stickyHeaders.length === 0) return;
            // 使用节流和防抖函数减少滚动事件处理频率
            let ticking = false;
            let lastScrollTop = 0;
            let scrollTimeout = null;
         const handleScroll = () => {
                // 清除之前的防抖定时器
                if (scrollTimeout) {
                    clearTimeout(scrollTimeout);
                }
                    // 设置防抖延迟，在滚动停止后100ms再处理
                scrollTimeout = setTimeout(() => {
                    if (!ticking) {
                        window.requestAnimationFrame(() => {
                            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            const scrollDelta = Math.abs(currentScrollTop - lastScrollTop);
                            // 如果滚动距离很小，跳过处理，避免抖动
                            if (scrollDelta < 10) {
                                ticking = false;
                                return;
                            }
                            lastScrollTop = currentScrollTop;
                                
             tables.forEach((table) => {
                 const tableTabIndex = parseInt(table.getAttribute('data-tab-index'));
                 const stickyHeader = Array.from(stickyHeaders).find(h => 
                     parseInt(h.getAttribute('data-tab-index')) === tableTabIndex
                 );
                 if (!stickyHeader) return;
                 // 检查对应的content是否显示
                 const content = this.querySelector(`.qcd-compare-content[data-content-index="${tableTabIndex}"]`);
                 if (!content || content.getAttribute('show') !== '1') {
                     stickyHeader.classList.remove('show');
                     // 显示对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.remove('hide-when-sticky'));
                     return;
                 }
                                const rect = table.getBoundingClientRect();
                                // 只要表格还在视口内（底部距离视口底部 > 0），就显示固定头部
                                // 只有当表格完全离开视口上方时才隐藏（表格底部在视口顶部上方）
                                const isTableInViewport = rect.top < window.innerHeight && rect.bottom > 0;
                                const shouldShow = rect.top <= 250 && rect.bottom > 0;
                                const shouldHide = rect.bottom < 0;
                 
                                const isCurrentlyShown = stickyHeader.classList.contains('show');
                                        
                                if (isTableInViewport && shouldShow && !shouldHide) {
                                    if (!isCurrentlyShown) {
                     stickyHeader.classList.add('show');
                     // 隐藏对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.add('hide-when-sticky'));
                                    }
                 } else {
                                    if (isCurrentlyShown) {
                     stickyHeader.classList.remove('show');
                     // 显示对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.remove('hide-when-sticky'));
                                    }
                 }
             });
                            ticking = false;
                        });
                        ticking = true;
                    }
                }, 100); // 防抖延迟100ms，减少抖动
         };
        // 使用 IntersectionObserver 更准确地检测表格位置
        const observerOptions = {
            root: null,
                    rootMargin: '-300px 0px -200px 0px', // 使用 rootMargin 来提前触发
            threshold: [0, 0.1, 0.5, 1]
        };
         const intersectionObserver = new IntersectionObserver((entries) => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
             entries.forEach(entry => {
                 const table = entry.target;
                 const tableTabIndex = parseInt(table.getAttribute('data-tab-index'));
                 const stickyHeader = Array.from(stickyHeaders).find(h => 
                     parseInt(h.getAttribute('data-tab-index')) === tableTabIndex
                 );
                 if (!stickyHeader) return;
                 // 检查对应的content是否显示
                 const content = this.querySelector(`.qcd-compare-content[data-content-index="${tableTabIndex}"]`);
                 if (!content || content.getAttribute('show') !== '1') {
                     stickyHeader.classList.remove('show');
                     // 显示对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.remove('hide-when-sticky'));
                     return;
                 }
                            const rect = table.getBoundingClientRect();
                            const isCurrentlyShown = stickyHeader.classList.contains('show');
                            // 只要表格还在视口内（底部距离视口底部 > 0），就显示固定头部
                            // 只有当表格完全离开视口上方时才隐藏（表格底部在视口顶部上方）
                            const shouldShow = rect.top <= 280 && rect.bottom > 0;
                            const shouldHide = rect.bottom < 0;
                            if (shouldShow && !shouldHide) {
                                if (!isCurrentlyShown) {
                     stickyHeader.classList.add('show');
                     // 隐藏对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.add('hide-when-sticky'));
                                }
                 } else {
                                if (isCurrentlyShown) {
                     stickyHeader.classList.remove('show');
                     // 显示对应的产品项
                     const items = content.querySelectorAll('.qcd-compare-item');
                     items.forEach(item => item.classList.remove('hide-when-sticky'));
                                }
                 }
             });
                        ticking = false;
                    });
                    ticking = true;
                }
         }, observerOptions);
        tables.forEach(table => {
            intersectionObserver.observe(table);
        });
        // 同时使用滚动监听作为备用
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll, { passive: true });
        // 延迟执行初始检查，确保DOM完全加载
        setTimeout(() => {
            handleScroll();
        }, 100);
        // 初始检查
        handleScroll();
        // 监听tab切换，重新检查
        const mutationObserver = new MutationObserver(() => {
            handleScroll();
            // 重新观察所有表格
            tables.forEach(table => {
                intersectionObserver.observe(table);
            });
        });
        const contents = this.querySelectorAll('.qcd-compare-content');
        contents.forEach(content => {
            mutationObserver.observe(content, { attributes: true, attributeFilter: ['show'] });
        });
    }
    
    initMobileStickyHeader() {
        const mobileParamsWrappers = this.querySelectorAll('.qcd-mobile-params-wrapper');
        const mobileStickyHeaders = this.querySelectorAll('.qcd-mobile-sticky-header');
        if (mobileParamsWrappers.length === 0 || mobileStickyHeaders.length === 0) return;
            // 使用节流和防抖函数减少滚动事件处理频率
            let mobileTicking = false;
            let lastMobileScrollTop = 0;
            let mobileScrollTimeout = null;
        const handleScroll = () => {
            // 只在手机端执行
            if (window.innerWidth > 1024) {
                mobileStickyHeaders.forEach(header => {
                    header.classList.remove('show');
                });
                return;
            }
                // 清除之前的防抖定时器
                if (mobileScrollTimeout) {
                    clearTimeout(mobileScrollTimeout);
                }
                // 设置防抖延迟，在滚动停止后100ms再处理
                mobileScrollTimeout = setTimeout(() => {
                    if (!mobileTicking) {
                        window.requestAnimationFrame(() => {
                            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            const scrollDelta = Math.abs(currentScrollTop - lastMobileScrollTop);
                            // 如果滚动距离很小，跳过处理，避免抖动
                            if (scrollDelta < 10) {
                                mobileTicking = false;
                                return;
                            }
                            lastMobileScrollTop = currentScrollTop;
            mobileParamsWrappers.forEach((wrapper) => {
                const wrapperTabIndex = parseInt(wrapper.getAttribute('data-tab-index'));
                const mobileStickyHeader = Array.from(mobileStickyHeaders).find(h => 
                    parseInt(h.getAttribute('data-tab-index')) === wrapperTabIndex
                );
                if (!mobileStickyHeader) return;
                // 检查对应的content是否显示
                const content = this.querySelector(`.qcd-compare-content[data-content-index="${wrapperTabIndex}"]`);
                if (!content || content.getAttribute('show') !== '1') {
                    mobileStickyHeader.classList.remove('show');
                    // 显示对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.remove('hide-when-sticky'));
                    return;
                }
                            const rect = wrapper.getBoundingClientRect();
                                const isCurrentlyShown = mobileStickyHeader.classList.contains('show');
                                // 只要参数对比区域还在视口内（底部距离视口底部 > 0），就显示固定头部
                                // 只有当参数对比区域完全离开视口上方时才隐藏（底部在视口顶部上方）
                                const shouldShow = rect.top <= 70 && rect.bottom > 0;
                                const shouldHide = rect.bottom < 0;
                                if (shouldShow && !shouldHide) {
                                    if (!isCurrentlyShown) {
                    mobileStickyHeader.classList.add('show');
                    // 隐藏对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.add('hide-when-sticky'));
                                    }
                } else {
                                    if (isCurrentlyShown) {
                    mobileStickyHeader.classList.remove('show');
                    // 显示对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.remove('hide-when-sticky'));
                                    }
                }
            });
                            mobileTicking = false;
                        });
                        mobileTicking = true;
                    }
                }, 100); // 防抖延迟100ms，减少抖动
        };
        // 使用 IntersectionObserver 更准确地检测参数对比区域位置
        const observerOptions = {
            root: null,
                rootMargin: '-80px 0px -200px 0px', // 使用 rootMargin 来提前触发
            threshold: [0, 0.1, 0.5, 1]
        };
        const intersectionObserver = new IntersectionObserver((entries) => {
                if (!mobileTicking) {
                    window.requestAnimationFrame(() => {
            entries.forEach(entry => {
                const wrapper = entry.target;
                const wrapperTabIndex = parseInt(wrapper.getAttribute('data-tab-index'));
                const mobileStickyHeader = Array.from(mobileStickyHeaders).find(h => 
                    parseInt(h.getAttribute('data-tab-index')) === wrapperTabIndex
                );
                if (!mobileStickyHeader) return;
                // 只在手机端执行
                if (window.innerWidth > 1024) {
                    mobileStickyHeader.classList.remove('show');
                    return;
                }
                // 检查对应的content是否显示
                const content = this.querySelector(`.qcd-compare-content[data-content-index="${wrapperTabIndex}"]`);
                if (!content || content.getAttribute('show') !== '1') {
                    mobileStickyHeader.classList.remove('show');
                    // 显示对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.remove('hide-when-sticky'));
                    return;
                }
                            const rect = wrapper.getBoundingClientRect();
                            const isCurrentlyShown = mobileStickyHeader.classList.contains('show');
                            // 只要参数对比区域还在视口内（底部距离视口底部 > 0），就显示固定头部
                            // 只有当参数对比区域完全离开视口上方时才隐藏（底部在视口顶部上方）
                            const shouldShow = rect.top <= 60 && rect.bottom > 0;
                            const shouldHide = rect.bottom < 0;
                            if (shouldShow && !shouldHide) {
                                if (!isCurrentlyShown) {
                    mobileStickyHeader.classList.add('show');
                    // 隐藏对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.add('hide-when-sticky'));
                                }
                } else {
                                if (isCurrentlyShown) {
                    mobileStickyHeader.classList.remove('show');
                    // 显示对应的产品项
                    const items = content.querySelectorAll('.qcd-compare-item');
                    items.forEach(item => item.classList.remove('hide-when-sticky'));
                                }
                }
            });
                        mobileTicking = false;
                    });
                    mobileTicking = true;
                }
        }, observerOptions);
        mobileParamsWrappers.forEach(wrapper => {
            intersectionObserver.observe(wrapper);
        });
        // 同时使用滚动监听作为备用
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll, { passive: true });
        
        // 延迟执行初始检查，确保DOM完全加载
        setTimeout(() => {
            handleScroll();
        }, 100);
        // 初始检查
        handleScroll();
        // 监听tab切换，重新检查
        const mutationObserver = new MutationObserver(() => {
            handleScroll();
            // 重新观察所有参数对比区域
            mobileParamsWrappers.forEach(wrapper => {
                intersectionObserver.observe(wrapper);
            });
        });
        const contents = this.querySelectorAll('.qcd-compare-content');
        contents.forEach(content => {
            mutationObserver.observe(content, { attributes: true, attributeFilter: ['show'] });
        });
    }
    
    updateProductDisplay(itemIndex, optionIndex) {
            // 根据选中的选项更新产品图片和按钮
            const content = this.querySelector(`.qcd-compare-content[show="1"]`);
            if (!content) return;
            const select = content.querySelector(`.qcd-select[data-item="${itemIndex}"]`);
            if (!select) return;
            const selectedOption = select.options[select.selectedIndex];
            if (!selectedOption) return;
            const productImage = selectedOption.getAttribute('data-product-image');
            const productUrl = selectedOption.getAttribute('data-product-url');
            const productHandle = selectedOption.getAttribute('data-product-handle');
            // 更新所有相同位置的产品项
            const allItems = content.querySelectorAll(`.qcd-compare-item[data-item-index="${itemIndex}"]`);
            // 更新产品图片
            if (productImage) {
                allItems.forEach(item => {
                    let imgElement = item.querySelector('.qcd-product-image img');
                    if (!imgElement) {
                        // 如果图片元素不存在，创建一个
                        const imageContainer = item.querySelector('.qcd-product-image');
                        if (imageContainer) {
                            imgElement = document.createElement('img');
                            imgElement.className = 'qcd-product-img';
                            imgElement.loading = 'lazy';
                            imageContainer.appendChild(imgElement);
                        }
                    }
                    if (imgElement) {
                        // 更新图片源
                        imgElement.src = productImage;
                        // 生成不同尺寸的srcset
                        const baseUrl = productImage.split('?')[0];
                        const sizes = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400, 1600];
                        const srcset = sizes.map(size => `${baseUrl}?width=${size} ${size}w`).join(', ');
                        imgElement.srcset = srcset;
                        imgElement.loading = 'lazy';
                        // 确保图片可见
                        imgElement.style.display = '';
                        // 设置alt属性
                        if (!imgElement.alt && selectedOption.textContent) {
                            imgElement.alt = selectedOption.textContent.trim();
                        }
                    }
                });
            }
            // 更新 Learn More 按钮链接
            if (productUrl) {
                const learnMoreBtns = content.querySelectorAll(`.qcd-learn-more-btn[data-item="${itemIndex}"]`);
                learnMoreBtns.forEach(btn => {
                    btn.href = productUrl;
                });
            }
            // 更新 Buy Now 按钮的product handle
            const buyNowBtns = content.querySelectorAll(`.qcd-buy-now-btn[data-item="${itemIndex}"]`);
            buyNowBtns.forEach(btn => {
                if (productHandle) {
                    btn.setAttribute('data-product-handle', productHandle);
                } else {
                    btn.removeAttribute('data-product-handle');
                }
            });
            // 更新参数对比表格
            const productParams = selectedOption.getAttribute('data-product-params');
            const productId = selectedOption.getAttribute('data-product-id');
            const tabIndex = parseInt(select.getAttribute('data-tab'));
            let paramsArray = [];
            // 优先从 JSON 数据中获取（更可靠）
            if (productId) {
                const paramsDataScript = this.querySelector(`script[data-tab-index="${tabIndex}"].qcd-products-params-data`);
                if (paramsDataScript) {
                    try {
                        const paramsData = JSON.parse(paramsDataScript.textContent.trim());
                        if (paramsData[productId]) {
                            const paramIndexes = Object.keys(paramsData[productId]).sort((a, b) => parseInt(a) - parseInt(b));
                            paramsArray = paramIndexes.map(index => {
                                const value = paramsData[productId][index];
                                return value && value !== null && value !== undefined ? String(value) : '';
                            });
                        }
                    } catch (e) {
                        console.error('Failed to parse params data:', e);
                    }
                }
            }
            // 如果没有从 JSON 获取到，尝试从 data-product-params 属性获取
            if (paramsArray.length === 0 && productParams) {
                paramsArray = productParams.split('|||');
            }
            if (paramsArray.length > 0) {
                const table = content.querySelector('.qcd-params-table');
                const mobileParamsWrapper = content.querySelector('.qcd-mobile-params-wrapper');
                
                // 更新PC端表格
                if (table) {
                    paramsArray.forEach((paramValue, paramIndex) => {
                        const tableCell = table.querySelector(`td[data-product-index="${itemIndex}"][data-param-index="${paramIndex}"]`);
                        if (tableCell) {
                            // Interface 字段（Portable Monitors索引12，Digital Photo Frame索引11）：在英文句号+空格后换行
                            if (paramIndex === 12 || paramIndex === 11) {
                                // 检查是否是 Interface 字段（通过查找同一行的第一列）
                                const row = tableCell.closest('tr');
                                if (row) {
                                    const firstCell = row.querySelector('td:first-child');
                                    if (firstCell && firstCell.textContent.trim() === 'Interface') {
                                        let displayValue = paramValue && paramValue !== '' ? paramValue : '-';
                                        if (displayValue !== '-') {
                                            // 先清理多余的换行符
                                            displayValue = displayValue.replace(/\n{2,}/g, '\n');
                                            // 只替换句号+空格为句号+换行，不改变任何其他内容
                                            displayValue = displayValue.replace(/\. /g, '.\n');
                                            // 清理开头和结尾的换行符
                                            displayValue = displayValue.trim();
                                        }
                                        tableCell.textContent = displayValue;
                                    } else {
                                        tableCell.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                                    }
                                } else {
                                    tableCell.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                                }
                            } else {
                                tableCell.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                            }
                        }
                    });
                }
                
                // 更新手机端参数显示
                if (mobileParamsWrapper) {
                    paramsArray.forEach((paramValue, paramIndex) => {
                        const mobileParamValue = mobileParamsWrapper.querySelector(`.qcd-mobile-param-value[data-product-index="${itemIndex}"][data-param-index="${paramIndex}"]`);
                        if (mobileParamValue) {
                            // Interface 字段（Portable Monitors索引12，Digital Photo Frame索引11）：在英文句号+空格后换行
                            if (paramIndex === 12 || paramIndex === 11) {
                                // 检查是否是 Interface 字段（通过查找同一参数项的参数名称）
                                const paramItem = mobileParamValue.closest('.qcd-mobile-param-item');
                                if (paramItem) {
                                    const paramName = paramItem.querySelector('.qcd-mobile-param-name');
                                    if (paramName && paramName.textContent.trim() === 'Interface') {
                                        let displayValue = paramValue && paramValue !== '' ? paramValue : '-';
                                        if (displayValue !== '-') {
                                            // 先清理多余的换行符
                                            displayValue = displayValue.replace(/\n{2,}/g, '\n');
                                            // 只替换句号+空格为句号+换行，不改变任何其他内容
                                            displayValue = displayValue.replace(/\. /g, '.\n');
                                            // 清理开头和结尾的换行符
                                            displayValue = displayValue.trim();
                                        }
                                        mobileParamValue.textContent = displayValue;
                                    } else {
                                        mobileParamValue.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                                    }
                                } else {
                                    mobileParamValue.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                                }
                            } else {
                                mobileParamValue.textContent = paramValue && paramValue.trim() !== '' ? paramValue.trim() : '-';
                            }
                        }
                    });
                }
            }
    }
    
    handleResponsive() {
        const isMobile = window.innerWidth <= 1024;
            // 只更新当前显示的tab的items
            const contents = this.querySelectorAll('.qcd-compare-content');
            contents.forEach((content) => {
                const isCurrentTab = content.getAttribute('show') === '1';
                const items = content.querySelectorAll('.qcd-compare-item');
                if (isCurrentTab) {
                    // 只更新当前显示的tab的items
        items.forEach((item, index) => {
            if (isMobile) {
                // 移动端只显示前2个
                if (index < 2) {
                    item.style.display = 'flex';
                } else {
                    item.style.display = 'none';
                }
            } else {
                // PC端显示前3个
                if (index < 3) {
                    item.style.display = 'flex';
                } else {
                    item.style.display = 'none';
                }
            }
        });
                }
        // 更新手机端参数对比布局的显示状态
            const mobileParamsWrapper = content.querySelector('.qcd-mobile-params-wrapper');
            if (mobileParamsWrapper) {
                        if (isMobile && isCurrentTab) {
                    mobileParamsWrapper.style.display = 'block';
                } else {
                    mobileParamsWrapper.style.display = 'none';
                }
            }
            // 更新手机端固定头部的显示状态
            const mobileStickyHeader = content.querySelector('.qcd-mobile-sticky-header');
            if (mobileStickyHeader) {
                if (!isMobile) {
                    mobileStickyHeader.classList.remove('show');
                }
            }
        });
    }
    }

    if (!customElements.get('q-product-compare')) {
        customElements.define('q-product-compare', ProductCompare);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-review-slider-active"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let className = '.swiper-' + sid
      const swiper = new Swiper(className, {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          0: {
            spaceBetween: 12
          },
          750: {
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.qrevi-next',
          prevEl: '.qrevi-prev',
        }
      });
      let sliders = this.querySelectorAll('.swiper-slide');
      let oSwiper = this.querySelector('.qrevi-swiper');
      // let calcSwiper = () => {
      //   let w = swiper.$el[0].clientWidth
      //   let sw = 0
      //   sliders.forEach(s => {
      //     let width = s.clientWidth
      //     sw += width
      //   })
      //   if (w > sw) {
      //     oSwiper.setAttribute("center", "1")
      //   } else {
      //     oSwiper.setAttribute("center", "")
      //   }
      // }

      // window.addEventListener('resize', () => {
      //   calcSwiper()
      // })
      // calcSwiper()
    }
  }
  if (!customElements.get('q-reviews-cards')) {
    customElements.define('q-reviews-cards', ReviewsCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-review-slider"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let className = '.swiper-' + sid
      const swiper = new Swiper(className, {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.qrevi-next',
          prevEl: '.qrevi-prev',
        }
      });
      let sliders = this.querySelectorAll('.swiper-slide');
      let oSwiper = this.querySelector('.qrevi-swiper');
      // let calcSwiper = () => {
      //   let w = swiper.$el[0].clientWidth
      //   let sw = 0
      //   sliders.forEach(s => {
      //     let width = s.clientWidth
      //     sw += width
      //   })
      //   if (w > sw) {
      //     oSwiper.setAttribute("center", "1")
      //   } else {
      //     oSwiper.setAttribute("center", "")
      //   }
      // }

      // window.addEventListener('resize', () => {
      //   calcSwiper()
      // })
      // calcSwiper()
    }
  }
  if (!customElements.get('q-reviews-cards')) {
    customElements.define('q-reviews-cards', ReviewsCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-social-media-slide"] && !Shopify.designMode) return;
  try {
    
  class SocialCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let speed = this.getAttribute('speed') * 1
      let className = '.swiper-' + sid
      const swiper = new Swiper(className, {
        loop: true,
        speed: speed * 1000,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 20
          }
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 0
        },
        // navigation: {
        //   nextEl: '.qsms-next',
        //   prevEl: '.qsms-prev',
        // }
      });
      // let el = swiper.$el[0]
      // el.addEventListener('mouseover', function() {
      //   swiper.autoplay.stop();
      //   swiper.speed = 1
      // });

      // el.addEventListener('mouseout', function() {
      //   swiper.autoplay.start();
      //   swiper.speed = speed * 1000
      // });
    }
  }
  if (!customElements.get('q-social-cards')) {
    customElements.define('q-social-cards', SocialCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-video-slider"] && !Shopify.designMode) return;
  try {
    
class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let sectionId = this.getAttribute("section-id")
    let className = `.swiper-${sectionId}`
    const swiper = new Swiper(className, {
      loop: false,
      // spaceBetween: 12,
      // breakpoints: {
      //   2000: {
      //     centeredSlides: true
      //   }
      // },
      slidesPerView: 'auto',
      // slidesPerGroupAuto: false,
      navigation: {
        nextEl: '.qvs-next',
        prevEl: '.qvs-prev',
      }
    });

    let sliders = this.querySelectorAll('.swiper-slide');
    let oSwiper = this.querySelector('.qvs-swiper');
    let calcSwiper = () => {
      let w = swiper.$el[0].clientWidth
      let sw = 0
      sliders.forEach(s => {
        let width = s.clientWidth
        sw += width
      })
      if (w > sw) {
        oSwiper.setAttribute("center", "1")
      } else {
        oSwiper.setAttribute("center", "")
      }
    }

    window.addEventListener('resize', () => {
      calcSwiper()
    })
    calcSwiper()
    

    let oItems = this.querySelectorAll('.qvs-slider-a');
    let oVideos = this.querySelectorAll('.qvs-big-video');
    let oMask = this.querySelector('.qvs-mask');
    let oFull = this.querySelectorAll('.qvs-full-box');
    let oClose = this.querySelector('.qvs-mask-close');
    let index = 0
    oItems.forEach((item, i) => {
      item.addEventListener("click", () => {
        let url = item.getAttribute("data-url");
        if (url) {
          index = i
          oMask.setAttribute("show", "1")
          oFull.forEach(v => {
            // v.style.display = 'none'
            v.setAttribute("show", "")
          })
          oFull[i].setAttribute("show", "1")
          console.log(oFull[i])
          oVideos[i].play()
        }
      })
    })
    oClose.addEventListener("click", () => {
      oMask.setAttribute("show", "")
      oVideos[index].pause()
    })
  }
}
if (!customElements.get('q-video-slider')) {
  customElements.define('q-video-slider', VideoSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider-2"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCards extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      let className = '.swiper-' + sid
      const swiper = new Swiper(className, {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
          750: {
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: this.querySelector('.qrevi-next'),
          prevEl: this.querySelector('.qrevi-prev')
        }
      });
    }
  }
  if (!customElements.get('q-reviews-cards-2')) {
    customElements.define('q-reviews-cards-2', ReviewsCards);
  }

  } catch(e) { console.error(e); }
})();
})();
